import React, { ChangeEvent, useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import Swal from 'sweetalert2';
import {
  Categoria,
  ContaBanco,
  Finalizadora,
  InputNumber2 as InputNumber,
  InputPercent,
  InputSelect,
} from '~/components/NovosInputs';
import Separator from '~/components/Separator';
import ToggleDefault from '~/components/ToggleDefault';
import { useRegraLoja } from '~/pages/RegraDeLoja/RegraLojaContext';
import api from '~/services/api';
import { errorHandler } from '~/utils/ErrorHandler';
import { BuscaFornecedor } from '../../components/BuscaFornecedor';
import {
  Condicao,
  IInterface,
  ISelect,
  SelectType,
  tipoEstoque,
  tipoRegime,
  tipoRegimeFCP,
} from '../../types';

const Geral = () => {
  const {
    formRegraLoja,
    changeFormRegraLoja,
    initInicializado,
    setFormRegraLoja,
    formTela: {
      register,
      setValue,
      control,
      formState: { errors },
      clearErrors,
      getValues,
    },
    contaBancoRetriever,
    setContaBancoRetriever,
    finalizadoraRetriever,
    setFinalizadoraRetriever,
    setCategoriaRetriever,
    categoriaRetriever,
    setFornecedorRetriever,
    fornecedorRetriever,
  } = useRegraLoja();
  const [interfacePDV, setInterfacePdvs] = useState<ISelect[]>([]);
  const [interfacePDVAtiva, setInterfacePdvsAtiva] = useState<ISelect[]>([]);
  const [condicoes, setCondicoes] = React.useState<ISelect[]>([]);
  const disabled = true;
  useEffect(() => {
    // busca as interfaces de PDV
    api.get('/interface/0').then((res) => {
      const { data, success } = res.data;
      if (success) {
        const interfaces = data.map((inter: IInterface) => {
          return {
            value: inter.cod_interface,
            label: inter.des_interface,
          };
        });
        setInterfacePdvs(interfaces);
        setValue('interfaces', interfaces);

        const interfaceAtiva = data
          .filter((d: any) => d.flg_inativo !== true)
          .map((i: IInterface) => ({
            value: i.cod_interface,
            label: i.des_interface,
          }));

        setInterfacePdvsAtiva(interfaceAtiva);
      }
    });
    getCondicoes();
  }, []);

  const getCondicoes = async () => {
    try {
      const res = await api.get('/condicao');
      const { success, data, message } = res.data;
      if (!success) throw new Error(message);
      const options: ISelect[] = data.map((condicao: Condicao) => ({
        label: `${condicao.des_condicao} - ${condicao.des_definicao}`,
        value: condicao.cod_condicao,
      }));
      setCondicoes(options);
    } catch (error: any) {
      errorHandler(error);
    }
  };

  useEffect(() => {
    getCondicoes();
  }, []);

  const handleChangeTipoRegime = (value: SelectType) => {
    const { tipo_regime } = getValues();
    if (tipo_regime.label === value.label) return;
    setValue('tipo_regime', value);
    changeFormRegraLoja({
      ...formRegraLoja,
      tipo_regime: {
        ...formRegraLoja.tipo_regime,
        value,
        isInvalid: value.value === undefined,
      },
    });
    if (value.label === 'Optante Simples') AlertIncidePISCofins();
    clearErrors('tipo_regime');
  };

  async function AlertIncidePISCofins() {
    await Swal.fire({
      text: 'Alterar o regime para Optante do Simples implica na necessidade de informar o CSON no cadastro de tributação',
      icon: 'warning',
      showCancelButton: false,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'ESTOU CIENTE',
      cancelButtonText: 'Não',
    });
  }

  return (
    <>
      <Row>
        <Col sm={12}>
          <Separator labelText="Imposto" />
        </Col>
        <Col sm={12} md={3}>
          <InputSelect
            options={tipoRegime}
            label="Regime Tributário *"
            placeholder="Selecione"
            control={control}
            register={register}
            name="tipo_regime"
            isError={!!errors.tipo_regime}
            changeSelected={(selected: SelectType) => {
              handleChangeTipoRegime(selected);
            }}
          />
        </Col>

        <Col sm={12} md={3}>
          <InputSelect
            label="Regime FCP *"
            name="tipo_regime_fcp"
            placeholder="Selecione"
            register={register}
            control={control}
            options={tipoRegimeFCP}
            isError={!!errors.tipo_regime_fcp}
            changeSelected={(selected) => {
              setValue('tipo_regime_fcp', selected);
              changeFormRegraLoja({
                ...formRegraLoja,
                tipo_regime_fcp: {
                  ...formRegraLoja.tipo_regime_fcp,
                  value: selected,
                  isInvalid: selected.value === undefined,
                },
              });
              clearErrors('tipo_regime_fcp');
            }}
          />
        </Col>

        <Col sm={12} md={3}>
          <InputPercent
            label="Despesas Operacionais *"
            min={0}
            max={100}
            name="val_desp_operacional"
            placeholder="0,00"
            step=".01"
            isError={!!errors.val_desp_operacional}
            register={register}
            control={control}
          />
        </Col>
        <Col sm={12} md={3}>
          <ToggleDefault
            labelText="Trunca Valores de Débito ICMS?"
            setChecked={formRegraLoja.flg_trunca_val_deb_icms.value}
            onSwitch={() => {
              setValue(
                'flg_trunca_val_deb_icms',
                !formRegraLoja.flg_trunca_val_deb_icms.value,
              );
              changeFormRegraLoja({
                ...formRegraLoja,
                flg_trunca_val_deb_icms: {
                  ...formRegraLoja.flg_trunca_val_deb_icms,
                  value: !formRegraLoja.flg_trunca_val_deb_icms.value,
                },
              });
            }}
          />
        </Col>

        {/* <div className="col-sm-12 col-md-12 mt-2">
          <ToggleDefault
            labelText="Ignora Impostos de ST do Conhecimento de Frete no Custo da Mercadoria?"
            setChecked={formRegraLoja.flg_ignora_st_cf_custo.value}
            onSwitch={() => {
              setValue(
                'flg_ignora_st_cf_custo',
                !formRegraLoja.flg_ignora_st_cf_custo.value,
              );
              changeFormRegraLoja({
                ...formRegraLoja,
                flg_ignora_st_cf_custo: {
                  ...formRegraLoja.flg_ignora_st_cf_custo,
                  value: !formRegraLoja.flg_ignora_st_cf_custo.value,
                },
              });
            }}
          />
        </div> */}
      </Row>

      <Row>
        <Col sm={12}>
          <Separator labelText="GARE" />
        </Col>
        <Col sm={12} md={6}>
          <BuscaFornecedor
            label="Fornecedor SEFAZ"
            invalid={!!errors.cod_pessoa_sefaz}
            onChange={(data) => {
              setValue('cod_pessoa_sefaz', {
                value: data.value,
                label: data.label,
              });

              setFornecedorRetriever(null);

              setFormRegraLoja((prev) => {
                return {
                  ...prev,
                  cod_pessoa_sefaz: {
                    ...prev.cod_pessoa_sefaz,
                    value: data.value,
                  },
                  cod_cc_gare: {
                    ...prev.cod_cc_gare,
                    isRequired: true,
                    isInvalid: !prev.cod_cc_gare.value?.value,
                  },
                  cod_finalizadora_gare: {
                    ...prev.cod_finalizadora_gare,
                    isRequired: true,
                    isInvalid: !prev.cod_finalizadora_gare.value?.value,
                  },
                  num_condicao_gare: {
                    ...prev.num_condicao_gare,
                    isRequired: true,
                    isInvalid: !prev.num_condicao_gare.value,
                  },
                  cod_condicao_gare: {
                    ...prev.cod_condicao_gare,
                    isRequired: true,
                    isInvalid: !prev.cod_condicao_gare.value?.value,
                  },
                  cod_categoria_gare: {
                    ...prev.cod_categoria_gare,
                    isRequired: true,
                    isInvalid: !prev.cod_categoria_gare.value?.value,
                  },
                };
              });
            }}
            name="cod_pessoa_sefaz"
            register={register}
            control={control}
            retriever={fornecedorRetriever ?? undefined}
          />
        </Col>
        <Col sm={12} md={6} style={{ zIndex: 6 }}>
          <ContaBanco
            label="Conta"
            placeholder="Selecione"
            name="cod_cc_gare"
            loja={formRegraLoja.cod_loja.value.value}
            control={control}
            register={register}
            isError={!!errors.cod_cc_gare}
            retriever={contaBancoRetriever}
            allowNone={false}
            changeSelected={(value: any) => {
              setValue('cod_cc_gare', value);
              clearErrors('cod_cc_gare');
              setContaBancoRetriever(null);
              setFormRegraLoja((prev) => {
                return {
                  ...prev,
                  cod_cc_gare: {
                    ...prev.cod_cc_gare,
                    value,
                    isInvalid: value === undefined,
                  },
                };
              });
            }}
          />
        </Col>
        <Col sm={12} md={4}>
          <Finalizadora
            label="Finalizadora"
            placeholder="Selecione"
            control={control}
            isError={!!errors.cod_finalizadora_gare}
            loja={formRegraLoja.cod_loja.value.value}
            register={register}
            name="cod_finalizadora_gare"
            changeSelected={(value: any) => {
              setValue('cod_finalizadora_gare', value);
              setValue('num_condicao_gare', value.num_condicao);
              setValue('cod_condicao_gare', {
                value: value.cod_condicao,
                label: '',
              });
              clearErrors('cod_finalizadora_gare');
              clearErrors('cod_condicao_gare');
              clearErrors('num_condicao_gare');
              setFinalizadoraRetriever(null);
              setFormRegraLoja((prev) => {
                return {
                  ...prev,
                  cod_finalizadora_gare: {
                    ...prev.cod_finalizadora_gare,
                    value,
                    isInvalid: value === undefined,
                  },
                  num_condicao_gare: {
                    ...prev.num_condicao_gare,
                    value: value.num_condicao,
                    isInvalid: Number.isNaN(value.num_condicao),
                  },
                  cod_condicao_gare: {
                    ...prev.cod_condicao_gare,
                    value: { value: value.cod_condicao, label: '' },
                    isInvalid: !value.cod_condicao,
                  },
                };
              });
            }}
            retriever={finalizadoraRetriever}
          />
        </Col>
        <Col sm={12} md={1}>
          <InputNumber
            label="Condição"
            name="num_condicao_gare"
            placeholder="0"
            register={register}
            control={control}
            maxLength={3}
            min={0}
            max={999}
            isError={!!errors.num_condicao_gare}
            onChange={(event: ChangeEvent<HTMLInputElement>) => {
              if (Number(event.target.value) <= 999)
                setValue('num_condicao_gare', event.target.value);
            }}
          />
        </Col>
        <Col sm={12} md={3}>
          <InputSelect
            label="Tipo de Condição"
            name="cod_condicao_gare"
            placeholder="Informe o Tipo"
            options={condicoes}
            isError={!!errors.cod_condicao_gare}
            control={control}
            register={register}
            changeSelected={(value: any) => {
              setValue('cod_condicao_gare', value);
              clearErrors('cod_condicao_gare');
              setFormRegraLoja((prev) => {
                return {
                  ...prev,
                  cod_condicao_gare: {
                    ...prev.cod_condicao_gare,
                    value,
                    isInvalid: !value.value,
                  },
                };
              });
            }}
          />
        </Col>
        <Col sm={12} md={4} style={{ zIndex: 5 }}>
          <Categoria
            label="Categoria"
            name="cod_categoria_gare"
            placeholder="Selecione"
            register={register}
            control={control}
            isError={!!errors.cod_categoria_gare}
            hideNoneOption
            tipoCategoria="Ambos"
            changeSelected={(value: any) => {
              setValue('cod_categoria_gare', value);
              clearErrors('cod_categoria_gare');
              setCategoriaRetriever(null);
              setFormRegraLoja((prev) => {
                return {
                  ...prev,
                  cod_categoria_gare: {
                    ...prev.cod_categoria_gare,
                    value,
                    isInvalid: !value.value,
                  },
                };
              });
            }}
            retriever={categoriaRetriever}
          />
        </Col>
      </Row>
      {!disabled && (
        <Row>
          <Col sm={12}>
            <Separator labelText="Preço" />
          </Col>
          <Col sm={12} md={3}>
            <InputPercent
              label="Margem Mínima"
              min={0}
              max={100}
              name="val_margem_venda"
              placeholder="0,00"
              step=".01"
              isError={!!errors.val_margem_venda}
              register={register}
              control={control}
            />
          </Col>

          <Col sm={12} md={3}>
            <InputNumber
              label="Meses Cálculo Venda Média"
              placeholder="0"
              name="num_meses_vm"
              register={register}
              control={control}
              min={0}
              max={12}
              maxLength={2}
              isError={!!errors.num_meses_vm}
              value={`${formRegraLoja.num_meses_vm.value ?? 0}`}
              onInput={(ev: any) => {
                const { value } = ev.target;
                const trimmedValue = value.toString().trim().slice(0, 2);

                if (trimmedValue.includes('-')) {
                  setValue('num_meses_vm', 0);
                  changeFormRegraLoja({
                    ...formRegraLoja,
                    num_meses_vm: {
                      ...formRegraLoja.num_meses_vm,
                      value: 0,
                    },
                  });
                } else if (trimmedValue <= 12 || Number.isNaN(trimmedValue)) {
                  setValue('num_meses_vm', trimmedValue);
                  changeFormRegraLoja({
                    ...formRegraLoja,
                    num_meses_vm: {
                      ...formRegraLoja.num_meses_vm,
                      value: trimmedValue,
                      isInvalid: Number.isNaN(trimmedValue),
                    },
                  });
                }
              }}
            />
          </Col>
        </Row>
      )}
      {/* <Row>
        <Col sm="12">
          <Separator labelText="PDV" />
        </Col>
        <Col md="3">
          <InputSelect
            options={tipoIntegraFrente}
            noOptionsMessage="Nenhum registro encontrado"
            label="Frente de Loja *"
            value={
              tipoIntegraFrente.find((item: ISelect) => {
                return (
                  item.value === formRegraLoja.tipo_integra_frente.value.value
                );
              }) ?? {
                value: undefined,
                label: 'Selecione',
              }
            }
            isRequired
            setInvalid={!!errors.tipo_integra_frente}
            iniInicializado={!!errors.tipo_integra_frente}
            onChange={(value: any, isInvalid = true) => {
              setValue('tipo_integra_frente', value);
              changeFormRegraLoja({
                ...formRegraLoja,
                tipo_integra_frente: {
                  ...formRegraLoja.tipo_integra_frente,
                  value,
                  isInvalid: value.value === undefined,
                },
              });
            }}
          />
        </Col>

        <div className="col-sm2 col-md-3">
          <InputSelect
            options={interfacePDVAtiva}
            noOptionsMessage="Nenhum registro encontrado"
            label="Interface *"
            value={
              interfacePDV.find((item: ISelect) => {
                return (
                  item.value ===
                  formRegraLoja.cod_interface_carga_pdv.value.value
                );
              }) ?? {
                value: undefined,
                label: 'Selecione',
              }
            }
            isRequired
            setInvalid={!!errors.cod_interface_carga_pdv}
            iniInicializado={!!errors.cod_interface_carga_pdv}
            onChange={(value: any, isInvalid = true) => {
              setValue('cod_interface_carga_pdv', value);
              changeFormRegraLoja({
                ...formRegraLoja,
                cod_interface_carga_pdv: {
                  ...formRegraLoja.cod_interface_carga_pdv,
                  value,
                  isInvalid: value.value === undefined,
                },
              });
            }}
          />
        </div>
        {!disabled && (
          <div className="com-sm-12 col-md-6">
            <InputText
              value={formRegraLoja.des_path_carga_pdv.value || ''}
              maxLength={500}
              label="Salvar em"
              placeholder=""
              isRequired
              setInvalid={!!errors.des_path_carga_pdv}
              onChange={(value: string, isInvalid = false) => {
                setValue('des_path_carga_pdv', value);
                changeFormRegraLoja({
                  ...formRegraLoja,
                  des_path_carga_pdv: {
                    ...formRegraLoja.des_path_carga_pdv,
                    value,
                    isInvalid: value === '',
                  },
                });
              }}
            />
          </div>
        )}

        {formRegraLoja.tipo_integra_frente.value.label === 'ipdv' && (
          <div className="col-sm-12 col-md-5">
            <InputText
              value={formRegraLoja.des_path_banco_frente.value || ''}
              maxLength={500}
              label="Carga/Pedido PDV Banco a Banco"
              placeholder=""
              isRequired
              setInvalid={!!errors.des_path_banco_frente}
              onChange={(value: string, isInvalid = false) => {
                setValue('des_path_banco_frente', value);
                changeFormRegraLoja({
                  ...formRegraLoja,
                  des_path_banco_frente: {
                    ...formRegraLoja.des_path_banco_frente,
                    value,
                    isInvalid: value === '',
                  },
                });
              }}
            />
          </div>
        )}
        {!disabled && (
          <div className="col-sm-12 col-md-6 mt-3">
            <ToggleDefault
              labelText="Compactar Arquivos na Geração da Carga?"
              setChecked={formRegraLoja.flg_compacta_arq_pdv.value}
              onSwitch={() => {
                setValue(
                  'flg_compacta_arq_pdv',
                  !formRegraLoja.flg_compacta_arq_pdv.value,
                );
                changeFormRegraLoja({
                  ...formRegraLoja,
                  flg_compacta_arq_pdv: {
                    ...formRegraLoja.flg_compacta_arq_pdv,
                    value: !formRegraLoja.flg_compacta_arq_pdv.value,
                  },
                });
              }}
            />
          </div>
        )}
        {!disabled &&
          [0, 3, 4].includes(formRegraLoja.tipo_integra_frente.value.value) && (
            <div className="col-sm-8 col-md-6 mt-3">
              <ToggleDefault
                labelText="Enviar PLU (Posição 1-20 ESTOQUE.TXT)?"
                setChecked={formRegraLoja.flg_enviar_plu_frente.value ?? false}
                onSwitch={() => {
                  setValue(
                    'flg_enviar_plu_frente',
                    !formRegraLoja.flg_enviar_plu_frente.value,
                  );
                  changeFormRegraLoja({
                    ...formRegraLoja,
                    flg_enviar_plu_frente: {
                      ...formRegraLoja.flg_enviar_plu_frente,
                      value: !formRegraLoja.flg_enviar_plu_frente.value,
                    },
                  });
                }}
              />
            </div>
          )}
      </Row> */}
      <Row>
        <Col md={12} sm={12}>
          <Separator labelText="Estoque" />
        </Col>
        <Col md={3} sm={12}>
          <InputSelect
            name="tipo_estoque_pedido_venda"
            label="Pedido de Vendas"
            options={tipoEstoque}
            register={register}
            control={control}
            isError={false}
            changeSelected={(selected) => {
              setValue('tipo_estoque_pedido_venda', selected);
            }}
          />
        </Col>
      </Row>
    </>
  );
};

export default Geral;
